<template>
  <div>
      <div class="box box--white ssv-course-header">
            <div class="ssv-course-header__name">
              <h3>{{formatDate}} - {{course.name}}</h3>
              <p>{{trainingCenter.name}}, {{trainingCenter.street}}, {{trainingCenter.city}} {{trainingCenter.zipCode}}</p>
            </div>
          <div class="ssv-course-header__price">
              <div class="ssv-course-header__price-value">
                  {{course.priceVat}} Kč
              </div>
              <div>
                  {{course.priceForNumberOfParticipants === 1 ? 'za osobu' : 'za kurz'}}
              </div>
          </div>
      </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import moment from 'moment';

    export default {
        name: 'SsvOrderHeaderCertification',
        computed: {
            ...mapGetters('ssvOrder', ['course', 'courseDate', 'trainingCenter']),
            formatDate() {
                const {dateOfEvent} = this.courseDate;
                return moment(dateOfEvent).format('DD. MM. YYYY');
            }
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/header/HeaderCertification.vue